import React from 'react';
import { FormFieldComponent, FormFieldComponentProps } from './types';
import { Field } from 'redux-form';

export const FormField = <T extends FormFieldComponent>(props: FormFieldComponentProps<T>) => {
	const { component, componentProps, controlProps, previewProps, ...fieldProps } = props;

	return (
		<Field
			component={component}
			{...fieldProps}
			controlProps={controlProps}
			componentProps={componentProps}
			previewProps={previewProps}
		/>
	);
};
